// src/components/Navbar.jsx
import React from 'react';
import {
  Navbar as BSNavbar,
  Container,
  Nav,
  Dropdown
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ onLogout }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <BSNavbar
      className="navbar-custom"
      style={{
        backgroundColor: '#212529',
        color: 'white',
        minHeight: '45px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <Container fluid>
        <BSNavbar.Brand style={{ color: 'white' }}>CLAUGER S.A</BSNavbar.Brand>
        <Nav className="ms-auto">
          <Dropdown align="end">
            <Dropdown.Toggle variant="outline-light" size="sm" id="perfil-dropdown">
              {user?.toUpperCase() || 'GUEST'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => navigate('/cambiar-password')}>
                Cambiar contraseña
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={onLogout}>Cerrar sesión</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Container>
    </BSNavbar>
  );
};

export default Navbar;
